import React from 'react';
import '../../styles/input.scss';

function Textarea({
  input,
  label,
  placeholder,
  disabled,
  onKeyPress,
  onKeyUp,
  readOnly,
  meta: { touched, error, invalid, warning },
}) {
  if (readOnly) input.readOnly = true;
  return (
    <>
      <label className="input-label" htmlFor={input.name}>
        {label}
      </label>
      <div className={`input-group mb-3`} style={{ marginTop: !label && -25 }}>
        <textarea
          {...input}
          id={input.name}
          value={input.value}
          className={`form-control ${readOnly ? 'no-select' : ''} ${
            touched && invalid ? 'is-invalid' : ''
          } `}
          placeholder={placeholder}
          disabled={disabled}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
        />
      </div>
    </>
  );
}

export default Textarea;
